export interface LineThicknessOptionProps {
  min?: number;
}

export const LINE_THICKNESS_MIN = 1;
export const LINE_THICKNESS_MAX = 15;